import { useEffect, useState } from 'react'
import LeftSide from './LeftSide'
import { LayoutNarrowTwo, LayoutTwo } from '../../Layout/CommonStyle'
import Main from './Main'
import { asyncGetMentees } from '../../../store/mainSlice'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { Mentee, User } from '../../../models/User'
import styled from 'styled-components'
import { ApiResult, LoadingStatus } from '../../../models/Enums'
import { useSelector } from 'react-redux'
import { axiosGet } from '../../Common/Axios'
import { UserGroup } from '../../../models/UserGroup'
import { setSelectGroupId } from '../../../store/userSlice'

function MentorMentee() {
  const [selectedGroup, setSelectedGroup] = useState(-1)
  const [selectedUser, setSelectedUser] = useState(-1)
  const [mentees, setMentees] = useState<Mentee[]>([])
  const [mentee, setMentee] = useState<Mentee | null>(null)

  const [students, setStudents] = useState<User[]>([])
  const [selectedStudent, setSelectedStudent] = useState<User | null>(null)

  const dispatch = useAppDispatch()
  const selectGroupId = useAppSelector(
    (state: RootState) => state.user.selectGroupId
  )

  const menteeGroups = useAppSelector(
    (state: RootState) => state.main.menteeGroups
  )
  const me = useAppSelector((state: RootState) => state.user.me)
  const menteesLoadingStatus = useAppSelector(
    (state: RootState) => state.main.loadingStatus
  )

  const loadStudents = async () => {
    const results = await axiosGet('/api/user/get_students/' + selectGroupId)
    if (results.apiResult !== ApiResult.SUCCESS) {
      console.log('get_students error', results.message)
      return
    }
    setStudents(results.data)
  }

  // 시작시 멘티를 로딩한다
  useEffect(() => {
    loadStudents()
  }, [])

  const updateGroupId = async (userId: number) => {
    const result = await axiosGet(`/api/user/group/${userId}`)
    console.log('result', result, 'userId', userId)
    const groups = result.data as UserGroup[]

    dispatch(setSelectGroupId(groups.length > 0 ? groups[0].id : 0))
  }

  useEffect(() => {
    if (selectGroupId === 0) {
      updateGroupId(me.id)
    }
    loadStudents()
  }, [selectGroupId])

  useEffect(() => {
    if (menteeGroups.length > 0) {
      setSelectedGroup(0)
    }
  }, [menteeGroups])

  useEffect(() => {
    if (selectedGroup < menteeGroups.length) {
      if (selectedGroup >= 0) {
        setMentees(menteeGroups[selectedGroup].users)

        if (menteeGroups[selectedGroup].users.length > 0) {
          setSelectedUser(0)
        }
      }
    }
  }, [selectedGroup])

  useEffect(() => {
    setMentee(mentees[selectedUser])
  }, [selectedUser])

  return (
    <>
      {menteesLoadingStatus === LoadingStatus.REJECTED && (
        <Error>데이터를 불러올 수 없습니다.</Error>
      )}
      <LayoutNarrowTwo>
        <Main mentee={mentee} student={selectedStudent} />
        <LeftSide
          students={students}
          selectedStudent={selectedStudent}
          setSelectedStudent={setSelectedStudent}
          //
          menteeGroups={menteeGroups}
          mentees={mentees}
          selectedGroup={selectedGroup}
          selectGroup={setSelectedGroup}
          selectedUser={selectedUser}
          selectUser={setSelectedUser}
          userListHeight="1800px"
        />
      </LayoutNarrowTwo>
    </>
  )
}

const Error = styled.div`
  text-align: center;
  width: 100%;
  background-color: red;
`
export default MentorMentee
